import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Products API
export const fetchProducts = async (category = null, limit = null) => {
  try {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (limit) params.append('limit', limit);
    
    const response = await axios.get(`${API}/products?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};

export const fetchProduct = async (id) => {
  try {
    const response = await axios.get(`${API}/products/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching product:', error);
    throw error;
  }
};

// Collections API
export const fetchCollections = async () => {
  try {
    const response = await axios.get(`${API}/collections`);
    return response.data;
  } catch (error) {
    console.error('Error fetching collections:', error);
    throw error;
  }
};

// Testimonials API
export const fetchTestimonials = async () => {
  try {
    const response = await axios.get(`${API}/testimonials`);
    return response.data;
  } catch (error) {
    console.error('Error fetching testimonials:', error);
    throw error;
  }
};

// Blog Posts API
export const fetchBlogPosts = async (limit = null) => {
  try {
    const params = new URLSearchParams();
    if (limit) params.append('limit', limit);
    
    const response = await axios.get(`${API}/blog?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    throw error;
  }
};

export const fetchBlogPost = async (id) => {
  try {
    const response = await axios.get(`${API}/blog/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blog post:', error);
    throw error;
  }
};

// Newsletter API
export const subscribeNewsletter = async (data) => {
  try {
    const response = await axios.post(`${API}/newsletter/subscribe`, data);
    return response.data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
};
